import useChatStore, { COLUMNS, GRID, ROWS } from 'Components/Chat/store';
import { useChatMessagesContext } from 'Context/Chat/ChatMessagesContext';
import { memo, useMemo } from 'react';
import GridCard from './components/GridCard';
import GridContainer from './components/GridContainer';
import TabView from './components/TabView';

const StreamingMessage = () => {
  const { streamingMessage, loading } = useChatMessagesContext();
  const renderType = useChatStore((state) => state.renderType);

  const isGridView = useMemo(() => {
    switch (renderType) {
      case COLUMNS:
      case ROWS:
      case GRID:
        return true;
      default:
        return false;
    }
  }, [renderType]);

  return (
    <div className="w-full">
      {streamingMessage && loading && (
        <>
          {isGridView ? (
            <GridContainer>
              {Array.isArray(streamingMessage) ? (
                streamingMessage.map((message, index) => (
                  <GridCard
                    key={'GRID_CARD_' + index}
                    message={message}
                    loading={loading}
                    isGridView
                    modelsIds={streamingMessage.map((m) => m.modelRef)}
                  />
                ))
              ) : (
                <GridCard
                  message={streamingMessage}
                  loading={loading}
                  modelsIds={[streamingMessage.modelRef]}
                />
              )}
            </GridContainer>
          ) : (
            <div className="w-full h-full grid gap-5 scrollbar-hidden lg:max-w-4xl m-auto">
              <TabView message={streamingMessage} loading={loading} />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default memo(StreamingMessage);
